import $ from 'jquery'

export const debounce = (fn, threshold) => {
    var timeout
    threshold = threshold || 100
    return function debounced() {
        clearTimeout(timeout)
        var args = arguments
        var _this = this
        function delayed() {
            fn.apply(_this, args)
        }
        timeout = setTimeout(delayed, threshold)
    }
}

export const getTextNodesIn = (node) => {
    let textNodes = []
    let nodeStack = [node]

    while (nodeStack.length > 0) {
        const currentNode = nodeStack.pop()
        if (currentNode.nodeType === Node.TEXT_NODE) {
            textNodes.push(currentNode)
        } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
            const children = currentNode.childNodes
            for (let i = children.length - 1; i >= 0; i--) {
                nodeStack.push(children[i])
            }
        }
    }

    return textNodes
        .map((node) => node.textContent.trim())
        .join('')
        .replace(/\s+/g, ' ')
}
